import EditTenant from './EditTenant';

export default EditTenant;
